import { useCartContext } from "app/providers/CartProvider";
import { useOrderContext } from "app/providers/OrderProvider";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { useCreateBumbalDate } from "../checkout/useCreateBumbalDate";

export const useAppointmentSubmitBumbalDate = () => {
  const { order, type } = useOrderContext();
  const { mutateBumbalDate, bumbalDateCreateStatus, isCreatingBumbalDate } =
    useCreateBumbalDate();
  const navigate = useNavigate();
  const { resetCart } = useCartContext();

  const submitBumbalDate = (selectedDate: Date | null) => {
    mutateBumbalDate(selectedDate);
  };

  useEffect(() => {
    if (bumbalDateCreateStatus === "success") {
      navigate(`/afspraak-bedankt?type=${type}&reference=${order!.id}`, {
        replace: true,
      });
      window.location.reload();
      resetCart();
    } else if (bumbalDateCreateStatus === "error") {
      toast.error("Er is iets fout gegaan met het maken van uw bumbaldate.");
    }
  }, [bumbalDateCreateStatus]);

  return {
    submitBumbalDate,
    isCreatingBumbalDate,
  };
};
